class PlatIngredient{
    constructor(
        public id_plat: number = 0,
        public id_ingredient: number = 0,
        public qInfantil: number = 0,
        public qPrimaria: number = 0,
        public qAdult: number = 0,
        public per100: number = 0,
    ){
    }
}
export {PlatIngredient}